export default "__VITE_ASSET__BTvAxg_8__"